import { STOP } from "../../utils/constants";
import { createSlice } from "@reduxjs/toolkit";

export interface SerializedError {
  name?: string;
  message?: string;
  stack?: string;
  code?: string;
}

export interface timeLineSlice {
  loading: string;
  currentRequestId: undefined;
  error: SerializedError;
  show: boolean;
  times: Array<number>;
  minValue: number | any;
  maxValue: number | any;
  status: string;
  currentTime: number | any;
  selectedTime: number | any;
  dateFields: Array<string>;
  layerId: string | any;
  selectedField: string | any;
  features: Array<object | any>;
  value: any | number;
}
var error: SerializedError = {};

const initialState: timeLineSlice = {
  loading: "idle",
  currentRequestId: undefined,
  error: error,
  show: true,
  times: [], //[1728579712805 - 10*60*60*1000, 1729184512805 - 10*60*60*1000],
  minValue: null, //728579712805 - 10*60*60*1000,
  maxValue: null, //1729184512805 - 10*60*60*1000,
  status: STOP, // STOP or START
  currentTime: null,
  selectedTime: null,
  dateFields: [],
  layerId: null,
  selectedField: null,
  features: [],
  value: null,
};

export const timeLineSlice = createSlice({
  name: "timeline",
  initialState: initialState,
  reducers: {
    setShowTimeLine: (state, action) => {
      state.show = action?.payload;
    },
    changeTimes: (state, action) => {
      state.times = action?.payload || [];
    },
    changeMinValue: (state, action) => {
      state.minValue = action?.payload;
    },
    changeMaxValue: (state, action) => {
      state.maxValue = action?.payload;
    },
    changeStatus: (state, action) => {
      state.status = action?.payload;
    },
    changeCurrentTime: (state, action) => {
      state.currentTime = action?.payload;
    },
    changeSelectedTime: (state, action) => {
      state.selectedTime = action?.payload;
    },
    changeDateFields: (state, action) => {
      state.dateFields = action?.payload;
    },
    changeLayerId: (state, action) => {
      state.layerId = action?.payload;
    },
    changeSelectedField: (state, action) => {
      state.selectedField = action?.payload;
    },
    changeFeatures: (state, action) => {
      state.features = action?.payload;
    },
    changeValue: (state, action) => {
      state.value = action?.payload;
    },
    reset: (state) => {
      state.show = true;
      state.times = [];
      state.minValue = null;
      state.maxValue = null;
      state.status = STOP;
      state.currentTime = null;
      state.selectedTime = null;
      state.dateFields = [];
      state.layerId = null;
      state.selectedField = null;
      state.features = [];
    },
  },
});

export const {
  setShowTimeLine,
  changeTimes,
  changeMinValue,
  changeMaxValue,
  changeStatus,
  changeCurrentTime,
  changeSelectedTime,
  reset,
  changeDateFields,
  changeLayerId,
  changeSelectedField,
  changeFeatures,
  changeValue,
} = timeLineSlice.actions;

export default timeLineSlice.reducer;
